import { apiClient } from '~shared/api';

export const checkIsValwinAdmin = (group: string): Promise<boolean> =>
  apiClient
    .options(`/admin/${group}`, { groupId: group })
    .then(() => true)
    .catch(() => false);
